<template>
  <div class="badge" @click="goToProfile(profileUrl)">
    <div v-bind="componentProps[layout]" class="badge__wrapper">
      <div class="badge__body">
        <div class="badge__score">
          <Icon :style="{color: textColor}" :class="[isLargeNumber ? 'badge__icon-bubble_large' : 'badge__icon-bubble']" name="text-bubble"/>
          <div :class="[isLargeNumber ? 'badge__icon-bubble_large' : 'badge__icon-bubble']">
            <span :style="{color: textColor}" class="badge__number">{{ number }}</span>
          </div>
        </div>
        <div :class="[isLargeNumber ? 'badge__title_large' : 'badge__title']">
          <a :style="{color: textColor}" :href="profileUrl" class="badge__text" v-html="$t('widgets.badges.number.text')"/>
        </div>
      </div>
      <div :class="[isLargeNumber ? 'badge__footer_large' : 'badge__footer']">
        <Icon :style="{color: checkmarkColor}" name="checkmark" class="badge__checkmark"/>
        <span :style="{color: textColor}" class="badge__signature">{{ $t('widgets.badges.number.signature') }}</span>
        <Icon :style="{color: textColor}" name="logo-trustfolio" class="badge__logo"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'BadgeNumber',
    props: {
        layout: {
            type: String,
            required: true
        },
        number: {
            type: Number,
            required: true
        },
        provider: {
            type: String,
            required: true
        },
        primary: {
            type: Boolean,
            required: true
        },
        profileUrl: {
            type: String,
            required: true
        }
    },
    computed: {
        primaryColor() {
            return this.primary || this.layout === 'alt'
                ? this.$store.state.primaryColor
                : '#1a1a1a';
        },
        textColor() {
            return this.layout === 'regular'
                ? '#ffffff'
                : this.layout !== 'alt'
                    ? this.primaryColor
                    : '#1a1a1a';
        },
        checkmarkColor() {
            return this.primary || this.layout === 'alt'
                ? this.textColor
                : '#49cc6a';
        },
        isLargeNumber() {
            return this.number > 99;
        },
        componentProps() {
            return {
                regular: {
                    style: `background: ${this.primaryColor}`
                },
                inverted: {
                    style: `background: #ffffff; border: 1px solid ${
                        this.primaryColor
                    }`
                },
                alt: {
                    style: `background: ${this.primaryColor}`
                }
            };
        }
    },
    methods: {
        goToProfile(url) {
            window.open(url, '_blank');
        }
    }
};
</script>

<style lang="scss" scoped>
.badge {
    position: relative;
    max-width: 208px;
    cursor: pointer;
    box-shadow: 0 5px 27px rgba($black, 0.07);
}

.badge__wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 8px;
    border-radius: 5px;
}

.badge__score {
    position: relative;
}

.badge__body {
    display: flex;
    flex-direction: row;
}

.badge__footer {
    display: flex;
    flex-direction: row;
    padding-top: 4px;
    align-items: center;
}

.badge__footer_large {
    display: flex;
    flex-direction: row;
    padding-top: 8px;
    align-items: center;
}

.badge__title {
    margin-left: 38px;
    line-height: 14px;
}

.badge__title_large {
    margin-left: 44px;
    line-height: 14px;
}

.badge__icon-bubble {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 32px;
    height: 38px;
}

.badge__icon-bubble_large {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 38px;
    height: 38px;
}

.badge__number {
    padding-top: 4px;
    font-weight: bold;
    font-size: 16px;
}

.badge__text {
    font-size: 12px;
    text-decoration: none;
}

.badge__signature {
    font-weight: normal;
    font-size: 9px;
    padding-top: 1px;
    margin-left: 3px;
    line-height: 16px;
}

.badge__checkmark {
    width: 8px;
}

.badge__logo {
    margin-left: 3px;
    padding-top: 2px;
    width: 42px;
}
</style>
